import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const categoriesApiSlice = createApi({
  reducerPath: 'categoriesApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.get(rest),
    }),
  }),
  serializeQueryArgs,
});

export const { useGetCategoriesQuery } = categoriesApiSlice;
